import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Rx';
import {FTA, Operacao, Layout, InstalacaoProduto, Cliente, Servico, ItemConfiguracao} from '../../model/catalogo';
import {GlobalService} from '../global.service';
import {UtilApi} from './util.api';

@Injectable()
export class DetalhamentoApiService {

    constructor(public http: HttpClient, public globalService: GlobalService) {
    }

    public detalhaFta(codigo: number, versao: number): Observable<FTA> {

        let url = this.globalService.getConfiguracao().api_catalogo + '/fta/' + codigo + '/' + versao;

        return this.http.get<FTA>(url, {headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'}});
    }

    public detalhaLayout(codigo: number, versao: number): Observable<Layout> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/layout/' + codigo + '/' + versao;

        return this.http.get<Layout>(url, {headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'}});
    }

    public detalhaInstalacaoProduto(codigo: number, versao: number): Observable<InstalacaoProduto> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/instalacaoProduto/' + codigo + '/' + versao;
        return this.http.get<InstalacaoProduto>(url, {headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'}});
    }

    public detalhaCliente(codigo: number, versao: number): Observable<Cliente> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/cliente/' + codigo + '/' + versao;

        return this.http.get<Cliente>(url, {headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'}});
    }

    public detalhaServico(codigo: number, versao: number): Observable<Servico> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/servico/' + codigo + '/' + versao;

        return this.http.get<Servico>(url, {headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'}});
    }

    /* Foi alterado por solicitação do Diego, para atender a regra não implementada - 13/09/2018*/
    public detalhaOperacao(codigo: number, versao: number): Observable<Operacao> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/operacao/' + codigo + '/' + 1;

        return this.http.get<Operacao>(url, {headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'}});
    }

    public detalhaItemConfiguracao(nome: string): Observable<ItemConfiguracao> {
        let url = this.globalService.getConfiguracao().api_catalogo + '/itemConfiguracao/' + nome;

        return this.http.get<ItemConfiguracao>(url, {headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'}});
    }
}



// WEBPACK FOOTER //
// ./src/service/api/detalhamento.api.ts